module.exports = __webpack_public_path__ + "img/tomato.86558f61.svg";